import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@wix/da-ds/pkg/Icons/Check';
import Error from '@wix/da-ds/pkg/Icons/24x24/Error';
import SystemNotification from '../../SystemNotification';
import Notification from '../Notification';
export var GenericNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, message = _a.message, messageLocaleKey = _a.messageLocaleKey, messageLocaleOptions = _a.messageLocaleOptions, _b = _a.isError, isError = _b === void 0 ? false : _b, _c = _a.cardProps, cardProps = _c === void 0 ? {} : _c;
    var t = useTranslation().t;
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: __assign({ iconComponent: isError ? Error : Check, isError: isError }, cardProps) }, message !== null && message !== void 0 ? message : t(messageLocaleKey !== null && messageLocaleKey !== void 0 ? messageLocaleKey : '', messageLocaleOptions)));
};
GenericNotification.displayName = 'GenericNotification';
export default GenericNotification;
//# sourceMappingURL=GenericNotification.js.map